import React, { CSSProperties } from "react";
import "../../stylesheet/_grid.scss";
import "../../stylesheet/components/singlecomponents/Button.scss";

const Button: React.FC<{
  name: string;
  buttonWhite?: boolean;
  style?: CSSProperties;
  bootstrapClass?: string;
}> = ({ name, buttonWhite = false, style, bootstrapClass }) => {
  return (
    <div
      style={style}
      className={`btn ${buttonWhite ? "btn-main" : "btn-second"} cta ${
        bootstrapClass ? bootstrapClass : ""
      }`}
    >
      {name}
    </div>
  );
};

export default Button;
